var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlkimaErfolgsgeschichteBwOnlineShopUmsatzGrafikStatistik(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 264,
    viewBox: "0 0 232 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.666 1.42676H0V263.628H230.666V1.42676Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.831 263.629C230.831 263.629 230.831 263.136 230.831 262.315C230.831 261.494 230.831 260.345 230.831 258.703C230.831 255.42 230.831 250.658 230.831 244.583C230.831 232.27 230.831 214.045 230.666 191.059C230.666 145.088 230.501 79.5786 230.501 1.42712L230.831 1.75549C162.901 1.75549 83.9236 1.75549 0.164883 1.75549L0.65952 1.26294C0.65952 97.9672 0.65952 188.104 0.65952 263.465L0.32976 263.136C69.744 263.136 127.287 263.3 167.682 263.3C187.798 263.3 203.626 263.3 214.508 263.465C219.949 263.465 224.071 263.465 226.874 263.465C229.347 263.629 230.831 263.629 230.831 263.629C230.831 263.629 229.347 263.629 226.709 263.629C223.906 263.629 219.784 263.629 214.508 263.629C203.791 263.629 187.963 263.629 167.847 263.793C127.452 263.793 69.744 263.957 0.32976 263.957H0V263.629C0 188.268 0 98.1314 0 1.42712V0.93457H0.494637C84.2534 0.93457 163.231 0.93457 231.161 0.93457H231.491V1.26294C231.491 79.5786 231.326 145.088 231.326 191.059C231.326 214.045 231.326 232.105 231.161 244.419C231.161 250.494 231.161 255.255 231.161 258.539C231.161 260.181 231.161 261.33 231.161 262.151C230.831 263.3 230.831 263.629 230.831 263.629Z",
    fill: "#3E3E53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.882 135.401C210.882 135.565 208.408 134.087 203.462 132.61C198.681 131.132 191.261 129.654 182.193 130.968C177.741 131.625 172.959 133.102 168.178 135.401C163.396 137.699 158.945 141.311 154.328 145.252C149.876 149.192 145.26 153.789 140.148 157.894C135.037 161.999 129.101 165.939 122.012 167.581C118.549 168.402 114.922 168.73 111.459 168.238C107.997 167.745 104.699 166.596 101.732 165.282C95.631 162.491 90.5197 158.715 85.2436 155.595C80.1323 152.476 75.021 149.849 69.7449 148.7C64.6336 147.386 59.5224 147.222 55.0706 147.55C46.0023 148.371 39.0773 151.491 34.7905 154.118C30.5036 156.745 28.3602 158.715 28.1953 158.551C28.1953 158.551 28.6899 158.058 29.6792 157.073C30.6685 156.088 32.3173 154.939 34.4607 153.461C38.7476 150.67 45.6725 147.222 54.9058 146.237C59.5224 145.744 64.6337 145.909 70.0747 147.222C75.5157 148.371 80.7918 150.998 85.9031 154.118C91.1792 157.237 96.2905 161.014 102.226 163.64C107.997 166.432 114.922 167.745 121.517 165.939C128.112 164.297 133.883 160.521 138.994 156.416C144.106 152.312 148.557 147.879 153.174 143.938C157.79 139.998 162.407 136.386 167.354 133.923C172.3 131.46 177.246 130.147 181.863 129.49C191.096 128.177 198.681 129.819 203.462 131.625C205.935 132.446 207.749 133.266 208.903 133.923C210.387 134.908 210.882 135.237 210.882 135.401Z",
    fill: "#FFB744"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2652 170.536H63.6445V223.403H83.2652V170.536Z",
    fill: "url(#paint0_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.367 170.536H146.746V223.403H166.367V170.536Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.23 139.506H174.609V223.404H194.23V139.506Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8745 206.82H38.2539V224.552H57.8745V206.82Z",
    fill: "url(#paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.964 194.344H91.3438V223.24H110.964V194.344Z",
    fill: "url(#paint4_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.664 187.776H119.043V223.404H138.664V187.776Z",
    fill: "url(#paint5_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9249 229.643C83.9249 230.136 79.1434 230.464 73.3726 230.464C67.6018 230.464 62.8203 230.136 62.8203 229.643C62.8203 229.151 67.6018 228.822 73.3726 228.822C79.3083 228.822 83.9249 229.151 83.9249 229.643Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5225 229.643C59.5225 230.136 54.741 230.464 48.9702 230.464C43.1995 230.464 38.418 230.136 38.418 229.643C38.418 229.151 43.1995 228.822 48.9702 228.822C54.9059 228.822 59.5225 229.151 59.5225 229.643Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.022 229.643C198.022 230.136 192.581 230.464 185.985 230.464C179.39 230.464 173.949 230.136 173.949 229.643C173.949 229.151 179.39 228.822 185.985 228.822C192.581 228.822 198.022 229.151 198.022 229.643Z",
    fill: "#263238"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.966 230.464C163.613 230.464 169.002 230.097 169.002 229.643C169.002 229.19 163.613 228.822 156.966 228.822C150.318 228.822 144.93 229.19 144.93 229.643C144.93 230.097 150.318 230.464 156.966 230.464Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.663 229.643C138.663 230.136 133.882 230.464 128.111 230.464C122.34 230.464 117.559 230.136 117.559 229.643C117.559 229.151 122.34 228.822 128.111 228.822C133.882 228.822 138.663 229.151 138.663 229.643Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.976 229.643C109.976 230.136 105.194 230.464 99.4233 230.464C93.6526 230.464 88.8711 230.136 88.8711 229.643C88.8711 229.151 93.6526 228.822 99.4233 228.822C105.194 228.822 109.976 229.151 109.976 229.643Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M198.021 39.6816H37.7578V106.012H198.021V39.6816Z",
    fill: "#E0E0E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0657 60.6977C71.0657 64.8023 67.7681 68.086 63.6461 68.086C59.5241 68.086 56.2266 64.8023 56.2266 60.6977C56.2266 56.593 59.5241 53.3093 63.6461 53.3093C67.7681 53.1452 71.0657 56.593 71.0657 60.6977Z",
    fill: "url(#paint6_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.586 55.4434H78.4844V58.3985H130.586V55.4434Z",
    fill: "url(#paint7_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M179.72 62.0107H78.4844V64.966H179.72V62.0107Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0657 83.5181C71.0657 87.6227 67.7681 90.9063 63.6461 90.9063C59.5241 90.9063 56.2266 87.6227 56.2266 83.5181C56.2266 79.4135 59.5241 76.1299 63.6461 76.1299C67.7681 76.1299 71.0657 79.4135 71.0657 83.5181Z",
    fill: "#3E3E53"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105.03 78.4287H78.4844V81.3839H105.03V78.4287Z",
    fill: "#3E3E53"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M179.72 84.9961H78.4844V87.9514H179.72V84.9961Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 83.2652,
    y1: 223.403,
    x2: 48.7746,
    y2: 210.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 166.367,
    y1: 223.403,
    x2: 131.876,
    y2: 210.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 194.23,
    y1: 223.404,
    x2: 157.024,
    y2: 214.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 57.8745,
    y1: 224.552,
    x2: 40.2331,
    y2: 205.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 110.964,
    y1: 223.24,
    x2: 84.106,
    y2: 205.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 138.664,
    y1: 223.404,
    x2: 108.554,
    y2: 206.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 71.0657,
    y1: 68.086,
    x2: 56.2835,
    y2: 53.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 130.586,
    y1: 58.3985,
    x2: 130.252,
    y2: 52.5071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlkimaErfolgsgeschichteBwOnlineShopUmsatzGrafikStatistik);
export default __webpack_public_path__ + "static/media/alkima-erfolgsgeschichte-bw-online-shop-umsatz-grafik-statistik.7f819ee3a278d6593989aff98c1e649a.svg";
export { ForwardRef as ReactComponent };